/** Explicit secrets require a personal award; ordinary patches require a holder. */
export const patchIsConcealed = (hidden, earned, earnedCount = 0) =>
  !earned && (Boolean(hidden) || !(earnedCount > 0));

export const concealedPatchLabel = reason => reason === 'not_unlocked' ? 'Not Unlocked' : 'Hidden';

/** Apply current visibility to older saved copies as well as fresh responses. */
export function concealUnopenedPatches(state) {
  const earned = new Set(state.awards.filter(award => !award.revoked_at).map(award => award.badge_id));
  const counts = new Map((state.statistics || []).map(stat => [stat.badge_id, stat.earned_count]));
  return {...state, definitions: state.definitions.map(definition => {
    if (!patchIsConcealed(definition.hidden, earned.has(definition.badge_id), counts.get(definition.badge_id)))
      return definition;
    const reason = definition.concealment_reason || (definition.hidden ? 'hidden' : 'not_unlocked');
    const {rule, progression_levels, progression_level, ...publicFields} = definition;
    return {...publicFields, name: concealedPatchLabel(reason), description: '', story: '', image: '', hidden: true, concealment_reason: reason};
  })};
}
